import React from "react";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { HStack } from "@design-system/HStack/HStack";
import styles from "./CounterpartyEditorDrawer.module.scss";

interface Props {
    submitLabel: string;
    formId?: string;
    isSubmitting?: boolean;
    onCancel: () => void;
}

export const CounterpartyEditorCommandBar: React.FC<Props> = ({
    submitLabel,
    formId,
    isSubmitting = false,
    onCancel,
}) => (
    <CommandIsland className={styles.commandBar}>
        <HStack gap={8} align="center">
            <Button variant="primary" size="md" onClick={onCancel}>
                Cancel
            </Button>
        </HStack>
        <HStack gap={8} align="center">
            <ButtonWithLoader
                type="submit"
                form={formId}
                variant="primary"
                size="md"
                loading={isSubmitting}
                hotKey="mod+enter"
                hotKeyDisplayPosition="inline"
                hotKeyOptions={{
                    description: submitLabel,
                    preventDefault: true,
                    enableOnFormTags: true,
                }}
            >
                {submitLabel}
            </ButtonWithLoader>
        </HStack>
    </CommandIsland>
);
